(function () {
    'use strict';

    function directPartnerConnectionsDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/directpartnerconnections/';

        function createBatch(data) {
            return $http.post(baseUrl + 'createbatch', data).then(
                function (response) {
                    return true;
                });
        }

        return {
            createBatch: createBatch
        }
    }

    directPartnerConnectionsDataService.$inject = ['$http'];

    angular.module('ecap.dashboards').service('directPartnerConnectionsDataService', directPartnerConnectionsDataService);
})();
